import styled from 'styled-components';


const Card = styled.div`
    width: 100%;
    height: 30vh;
    background: linear-gradient(${props => props.position === "left" ? 90 : 270}deg, ${props => props.color} 60%, rgba(198, 188, 171, 0.9) 0%);
    // border: 3px solid #000000;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;

    @media screen and (max-width: 426px) {
        width: 23.4375em;
        height: 9.2775em;
        border: 2px solid black;
        line-height: 22vh;
    }
`
const Container = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
`;

const Title = styled.div`
    width: 20vw;
    height: fit-content;
    font-family: "Oswald", sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 2.8vh;
    text-align: left;
    line-height: 35.05px;
    color: black;
    text-align: left;
    align-items: center;
    margin-left: ${props => props.position === "left" ? 1 : 16}em;
    @media screen and (max-width: 426px) {
        width: 12em;
        height: 4em;
        font-size: 13px;
        line-height: 19.27px;
        margin-left: ${props => props.position === "left" ? 1 : 16}em;
    }
`
const ByLine = styled.div`
width: 20vw;
    height: fit-content;
    font-family: "Oswald", sans-serif;
    font-weight: 400;
    font-size: 2.8vh;
    line-height: 35.05px;
    color: black;
    text-align: left;
    align-items: center;
    margin-left: ${props => props.position === "left" ? 1 : 16}em;
    @media screen and (max-width: 426px) {
        width: 11em;
        height: 4em;
        font-size: 12px;
        margin-left: 0.5em;
        margin-top: 1em;
        margin-left: ${props => props.position === "left" ? .25 : 16.5}em;
    }
`

const Image = styled.img`
    width: 62.5%;
    height: 30vh;
    object-fit: cover;
    border: 2px 2px 2px 0px;
    position: absolute;
    top: 0vh; 
    left: ${props => props.position === "left" ? 18.75: -0.25}vw;
    mask-image: linear-gradient(${props => props.position === "left" ? "to right" : "to left"}, rgba(0, 0, 0, 0) 20%, rgba(0, 0, 0, 1) 30%);
    @media screen and (max-width: 426px) {
        width: 16em;
        height: 10em;
        left: ${props => props.position === "left" ? 9: -2}em;
`


const ThirtyCard = (props) => {
    return (
        <>  
            <a href={props.article_url} style={{ textDecoration: 'none', color: 'inherit' }}>
                <Card color={props.color} position={props.position}>
                    <Container>
                        <Title position={props.position}>{props.article_title}</Title>
                        <ByLine position={props.position}>by {props.article_byline}</ByLine>
                    </Container>
                    <Image position={props.position} src={props.article_image} alt="Article image"/>
                </Card>
            </a>
        </>
    )
}

export default ThirtyCard;

